import useLocalStorage from '#layers/base/composables/useLocalStorage'

export type IProductTracking = {
  master_key?: string
  item_list_name?: string
  item_list_type?: string
  item_category?: string
  index?: number
}
interface IProductTrackingStorageFormat {
  // key is product ID
  [key: string]: IProductTracking
}

const defaultProductTrackingStore = {}

const { stored, set } = useLocalStorage<IProductTrackingStorageFormat>(
  'productTracking',
  defaultProductTrackingStore,
)
const useProductTrackingLocalStorage = () => {
  const getStoredProductTrackingItem = (
    itemId: string,
  ): IProductTracking | undefined => stored.value?.[itemId]

  const getStoredProductTrackingItemByMasterKey = (
    masterKey: string | number,
  ): IProductTracking | undefined => {
    const normalizedMasterKey = String(masterKey)
    const storedValues = Object.values(stored.value || {})
    return storedValues.find(
      (item) =>
        item.master_key != null &&
        String(item.master_key) === normalizedMasterKey,
    )
  }

  const storeProductTracking = (value: IProductTrackingStorageFormat) => {
    set({
      ...stored.value,
      ...value,
    })
  }

  const deleteProductTrackingItems = (itemIds: string[]) => {
    const storedCopy = Object.fromEntries(
      Object.entries(stored.value).filter(([key]) => !itemIds.includes(key)),
    )

    set(storedCopy)
  }

  return {
    getStoredProductTrackingItem,
    getStoredProductTrackingItemByMasterKey,
    storeProductTracking,
    deleteProductTrackingItems,
  }
}

export default useProductTrackingLocalStorage
